import { Injectable } from '@angular/core';
import { UiHelperService } from '../utils/services/ui-helper.service';
import ValidationRulesService from '../utils/services/validation-rules.service';

@Injectable ()
export class SlotsValidationService {
  constructor(
    private uiService: UiHelperService,
    private validationRulesService: ValidationRulesService
  ) {
  }

  public slotValidate(slotState: any): void {
    let selector = '';
    let isCorrectValue = false;
    let errorMsg = '';

    if (slotState.MNP_EDIT_STATE) {
      selector = 'tel-play-current-number-' + slotState.ordinal;
      isCorrectValue = this.isMsisdn(slotState.newMnpNumberValue);
      errorMsg = 'Kliknij Zatwierdź żeby dodać numer';
    }
    else if (slotState.RETENTION_EDIT_STATE) {
      selector = 'tel-play-retention-number-' + slotState.ordinal;
      isCorrectValue = this.isMsisdn(slotState.newRetentionNumberValue);
      errorMsg = 'Kliknij Dalej';
    }
    else if (slotState.UPSELL_EDIT_STATE) {
      selector = 'tel-play-current-number-' + slotState.ordinal;
      isCorrectValue = this.isMsisdn(slotState.upsellLoginNumberValue);
      errorMsg = 'Kliknij Dalej żeby dodać numer';
    }
    else if (slotState.PREPAID_2_POSTPAID_EDIT_STATE) {
      selector = 'tel-play-migration-number-' + slotState.ordinal;
      isCorrectValue = this.isMsisdn(slotState.newPrepaid2PostpaidNumberValue);
      errorMsg = 'Kliknij Dalej żeby dodać numer';
    }

    if (isCorrectValue) {
      this.validationRulesService.addInputError(selector, errorMsg);
    }
  }

  public slotsValidate(_unfinishedSlotStates: any[]) {
    //Zostawiłem to jak będziemy przerabiać tempState może się przydać
    // _unfinishedSlotStates
    //   .filter(_slot => _slot.hasOwnProperty('tempProcessType'))
    //   .forEach((slotState: any) => {
    //   this.slotValidate(slotState);
    // });

    this.uiService.scrollToElement('slot-' + _unfinishedSlotStates[0].ordinal);
  }

  private isMsisdn(_msisdn: string): boolean {
    //+48 111 111 111

    if (!_msisdn){
      return false;
    }

    const msisdn: string = _msisdn.replace(/\s|\+48|_/g, '');

    return msisdn.length === 9;
  }

}
